(function () {
  'use strict';
  if (customElements.get('sv-pdp-suggestions')) return;
  class Suggestions extends HTMLElement {
    connectedCallback() {
      if (this._ac) return;
      this._ac = new AbortController();
      this.list = this.querySelector('[data-sv-top-list]');
      this.addEventListener('click', (e) => {
        var button = e.target.closest('[data-sv-top-add]');
        if (!button || button.disabled) return;
        var card = button.closest('[data-sv-top-card]'), size = card.querySelector('[data-sv-top-size]'), status = card.querySelector('[role="status"]');
        if (!size.value) { status.textContent = 'Escolha um tamanho para adicionar.'; size.focus(); return; }
        if (!window.SV || !SV.cart) { status.textContent = 'A sacola está carregando. Tente novamente.'; return; }
        button.disabled = true; button.setAttribute('aria-busy', 'true'); status.textContent = '';
        SV.cart.add([{ id: Number(size.value), quantity: 1 }], { context: 'product', target: button }).then(() => {
          status.textContent = 'Adicionado à sacola.';
        }).catch((err) => {
          status.textContent = err?.response?.description || 'Não foi possível adicionar agora. Tente de novo.';
        }).finally(() => { button.disabled = false; button.removeAttribute('aria-busy'); });
      }, { signal: this._ac.signal });
      this.addEventListener('change', (e) => {
        if (!e.target.matches('select[data-sv-top-size]')) return;
        var option = e.target.selectedOptions[0], card = e.target.closest('[data-sv-top-card]');
        card.querySelector('[role="status"]').textContent = '';
        if (option.dataset.price && window.SV) card.querySelector('[data-sv-top-price]').textContent = SV.money(Math.round(Number(option.dataset.price) * (1 - Number(this.dataset.pix) / 100))) + ' no Pix';
      }, { signal: this._ac.signal });
      if (this.list.children.length >= 2) return;
      this._observer = new IntersectionObserver((entries) => {
        if (entries.some(e => e.isIntersecting)) { this._observer.disconnect(); this.load(); }
      }, { rootMargin: '600px' });
      this._observer.observe(this);
    }
    async load() {
      var status = this.querySelector('[data-sv-top-status]');
      try {
        var root = window.Shopify?.routes?.root || '/';
        var response = await fetch(root + 'recommendations/products?product_id=' + encodeURIComponent(this.dataset.productId) + '&limit=6&intent=related&section_id=sv-pdp-top-suggestions', { signal: this._ac.signal });
        if (!response.ok) throw new Error('recommendations');
        var html = new DOMParser().parseFromString(await response.text(), 'text/html');
        var ids = new Set(Array.from(this.list.children, c => c.dataset.productId));
        html.querySelectorAll('[data-sv-top-results] [data-sv-top-card]').forEach(card => {
          if (this.list.children.length >= 2 || ids.has(card.dataset.productId) || card.dataset.productId === this.dataset.productId) return;
          ids.add(card.dataset.productId); this.list.appendChild(document.importNode(card, true));
        });
        status.hidden = this.list.children.length > 0;
        status.textContent = 'Novas sugestões estarão disponíveis em breve.';
      } catch (error) {
        if (error.name === 'AbortError') return;
        status.hidden = this.list.children.length > 0;
        status.textContent = 'Não foi possível carregar as sugestões agora.';
      }
    }
    disconnectedCallback() { this._observer?.disconnect(); this._ac?.abort(); this._ac = null; }
  }
  customElements.define('sv-pdp-suggestions', Suggestions);
})();
